import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PanelBasicInlineBlock}
 */

const PanelBasicInline = ({
    title,
    text,
    buttons
}) => {

    return (
        <section className='col-padding'>
            <div className='px-16 pt-24 pb-16 rounded-lg flex-grow border border-border-default'>
                <h2 className='type-style-sans-h1 w-full md:w-7/12'>
                    {title}
                </h2>
                {text && (
                    <p className='type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'>
                        {text}
                    </p>
                )}
                {buttons?.length > 0 && (
                    <div className='mt-40 flex flex-wrap gap-x-8'>
                        {buttons.map((button, idx) => {
                            return (
                                <Button
                                    as='a'
                                    className={`${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                    href={formatLinkBlockToUrl(button.ctaLink)}
                                    key={button.id}>
                                    {button.ctaLabel}
                                </Button>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PanelBasicInline;
